import { render } from "./DangerButton.vue?vue&type=template&id=098d0ff4"
import script from "./DangerButton.vue?vue&type=script&lang=js"
export * from "./DangerButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DangerButton.vue"]])

export default __exports__